import {Container, PLATFORM, customAttribute, bindable, bindingMode, TaskQueue} from "aurelia-framework";
import {debounce} from "lodash";

@customAttribute('window-resize')
export class WindowResize {

  @bindable({
    primaryProperty: true,
    defaultBindingMode: bindingMode.oneTime
  }) resize = null;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) condition = true;

  __isListening: boolean;

  bind() {
    if (this.resize && this.condition) {
      if (!WindowResize.callbackList) {
        WindowResize.addResizeListener();
      }

      this.__isListening = true;
      WindowResize.callbackList.push(this.resize);
    }
  }

  unbind() {
    if (this.__isListening) {
      let list = WindowResize.callbackList;
      let length = list.length;

      if (length === 1) {
        WindowResize.removeResizeListener();
      } else {
        for (let i = length - 1; i >= 0; i--) {
          if (list[i] === this.resize) {
            list.splice(i, 1);
            break;
          }
        }
      }
    }
  }

  static taskQueue = Container.instance.get(TaskQueue);

  /**
   * @type {Function}
   * @static
   */
  static resizeListener;

  static callbackList = null;

  static addResizeListener() {
    WindowResize.callbackList = [];
    PLATFORM.addEventListener('resize', WindowResize.resizeListener = debounce(() => {
      let list = WindowResize.callbackList;
      for (let i = list.length - 1; i >= 0; i--) {
        WindowResize.taskQueue.queueMicroTask(list[i]);
        // PLATFORM.requestAnimationFrame(list[i]);
      }
    }, 16));
  }

  static removeResizeListener() {
    WindowResize.callbackList = null;
    PLATFORM.removeEventListener('resize', WindowResize.resizeListener);
  }

}

